import { Col, Layout, Row } from "antd";
import React, { useEffect, useState } from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { AffixC } from "src/shared/components";
import useAuth from "src/shared/hooks/useAuth";
import useDomain from "src/shared/hooks/useDomain";
import useSWR from "swr";
import FooterWhiteLable from "../FooterWhiteLable/FooterWhiteLable";
import HeaderWhiteLAble from "../HeaderWhiteLAble/HeaderWhiteLAble";
import HeaderWhiteLable2 from "../NewDesign/Public/HeaderWhiteLable2";
import "./layout.Public.Component.less";

const { Header, Sider, Content } = Layout;
const LayoutPublicComponent = ({ children }: any) => {
  const { isLogedIn, decode, logout } = useAuth();
  const roles: string[] = decode?.roles || [];
  const [state, setState] = useState({ collapsed: false });

  const {
    location: { pathname },
    push,
  } = useHistory();

  const { data: languages } = useSWR(`/localization/languages`);

  // const {data: domainConfig} = useSWR(`/domain/config`)

  const domainData = useDomain();

  console.log("domainData-*-*-*-**", domainData);

  const { t } = useTranslation();

  const headerPublicFunc = (val: number) => {
    switch (val) {
      case 1:
        return <HeaderWhiteLAble />;

      case 2:
        return <HeaderWhiteLable2 />;

      default:
        return <HeaderWhiteLAble />;
    }
  };

  return domainData ? (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Ld5XrIfAAAAAKLEH_FoIefFlAFomb7dotdgKB6_"
      language="fa"
    >
      {/* <script
        dangerouslySetInnerHTML={{
          __html: `${domainData?.scripts}`,
        }}
      /> */}
      <Row justify="center">
        <Col span={24} style={{ zIndex: 100 }}>
          <AffixC offsetTop={0}>
            {headerPublicFunc(Number(domainData?.headerPublic))}
          </AffixC>
        </Col>
        <Col
          style={{
            // height: "84vh",
            overflowY: "auto",
            overflowX: "hidden",
            textAlign: "center",
            background: "#F5F5F5",
          }}
          span={24}
        >
          <Row justify="center">
            <Col style={{ textAlign: "center" }} span={24}>
              {children}
            </Col>
          </Row>
        </Col>
        {Number(domainData?.headerPublic) != 2 ? (
          <Col
            style={{
              // height: "10vh",
              background: "#F5F5F5",
              padding: "10px 0",
              borderTop: ".5px solid rgba(0,0,0,.1)",
              textAlign: "center",
            }}
            span={24}
          >
            <FooterWhiteLable />
          </Col>
        ) : null}
      </Row>
    </GoogleReCaptchaProvider>
  ) : null;
};

export default LayoutPublicComponent;
